import React from 'react';
import clsx from 'clsx';
import './Box.less';
import PropTypes from 'prop-types';
import { Color } from '@/common/Color';

export const Box = ({
    children,
    padding,
    paddingTop,
    spacing,
    bgColor,
    color,
    horizontal,
    justifyContent,
    fontSize,
    fontWeight,
    className
}) => (
    <div
        className={clsx(
            'box',
            Number.isInteger(padding) ? 'padding-' + padding : null,
            Number.isInteger(paddingTop) ? 'padding-top-' + paddingTop : null,
            spacing ? 'spacing-' + spacing : null,
            horizontal ? 'horizontal' : null,
            justifyContent ? 'justify-content-' + justifyContent : null,
            bgColor ? 'bg-' + bgColor : null,
            color ? 'fg-' + color : null,
            fontSize ? 'font-size-' + fontSize : null,
            fontWeight ? 'font-weight-' + fontWeight : null,
            className ? className : null
        )}
    >
        {children}
    </div>
);

const colorPropTypes = PropTypes.oneOf([Color.paleGray, Color.white, Color.softRed, Color.black50, Color.mango]);
Box.propTypes = {
    padding: PropTypes.oneOf([6, 10, 20]),
    paddingTop: PropTypes.oneOf([0, 10, 20]),
    fontSize: PropTypes.oneOf([12, 14, 22]),
    fontWeight: PropTypes.oneOf([400, 500, 700]),
    spacing: PropTypes.oneOf([6, 10]),
    justifyContent: PropTypes.oneOf(['space-between', 'left']),
    color: colorPropTypes,
    bgColor: colorPropTypes
};
